import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CommunityInfo } from '../../types/community';
import { RoomsGrid } from '../../styles/CommunityChatRooms/CommunityChatRooms.styles';
import {
  PersonaCard,
  PersonaHeader,
  PersonaIcon,
  PersonaInfoSection,
  PersonaName,
  PersonaTagline,
  PersonaStats,
  StatItem,
  StatValue,
  StatLabel,
  JoinButton,
} from '../../styles/CommunityChatRooms/PersonaChatRoomCard.styles';
import {
  RoomListEmptyState,
  RoomListEmptyStateIcon,
  RoomListEmptyStateText,
  RoomListEmptyStateSubtext,
} from '../../styles/CommunityChatRooms/ChatRoomList.styles';

interface ChatRoomListProps {
  communities: CommunityInfo[];
}

export const ChatRoomList: React.FC<ChatRoomListProps> = ({ communities }) => {
  const navigate = useNavigate();

  const handleJoinRoom = (room: CommunityInfo) => {
    navigate(room.type === 'persona' ? `/community-chat-rooms/${room.slug}` : `/community-chat-rooms/room/${room.slug}`);
  };

  if (communities.length === 0) {
    return (
      <RoomListEmptyState>
        <RoomListEmptyStateIcon>💬</RoomListEmptyStateIcon>
        <RoomListEmptyStateText>No chat rooms available yet</RoomListEmptyStateText>
        <RoomListEmptyStateSubtext>
          Be the first to create one!
        </RoomListEmptyStateSubtext>
      </RoomListEmptyState>
    );
  }

  return (
    <RoomsGrid>
      {communities.map((room) => (
        <PersonaCard key={room.id}>
          <PersonaHeader>
            <PersonaIcon>{room.icon}</PersonaIcon>
            <PersonaInfoSection>
              <PersonaName>{room.name}</PersonaName>
              <PersonaTagline>{room.description}</PersonaTagline>
            </PersonaInfoSection>
          </PersonaHeader>

          <PersonaStats>
            <StatItem>
              <StatValue>{room.memberCount.toLocaleString()}</StatValue>
              <StatLabel>Members</StatLabel>
            </StatItem>
          </PersonaStats>

          <JoinButton onClick={() => handleJoinRoom(room)}>
            Join Room
          </JoinButton>
        </PersonaCard>
      ))}
    </RoomsGrid>
  );
};
